const listingFileUpload = {
  UPLOAD_PUPPY_FILE_REQUEST: 'UPLOAD_PUPPY_FILE_REQUEST',
  UPLOAD_PUPPY_FILE_SUCCESS: 'UPLOAD_PUPPY_FILE_SUCCESS',
  UPLOAD_PUPPY_FILE_ERROR: 'UPLOAD_PUPPY_FILE_ERROR',
};

export default listingFileUpload;
